import { ExtForm } from '../../ExtForms/components';
import { useExtFormStepController } from '../../ExtForms/hooks';
import { mockExtForm } from './helpers';
import { useFormEditContext } from './context';

export const MockExtForm: React.FC = () => {
  const { form, attachments, template } = useFormEditContext();
  const data = mockExtForm({ form, attachments, template });
  const extFromNavigation = useExtFormStepController(data);

  return (
    <ExtForm
      disableRestoreData
      sx={{ minHeight: '100%' }}
      formSlug={`${form.slug}`}
      data={data}
      active={extFromNavigation.active}
      steps={extFromNavigation.steps}
      setStep={extFromNavigation.setStepByIndex}
      nextStep={extFromNavigation.nextStep}
      prevStep={extFromNavigation.prevStep}
      sendForm={() => extFromNavigation.setStepByName('submitted')}
      currentStepsName={extFromNavigation.currentStepsName}
    />
  );
};
